import { BOOK_CHAPTER_SORTED } from "redux/types";
import bookChaptersUpdated from "./bookChaptersUpdated";

export default function bookFlowItemReorder(osbn, chapterId, newKeys) {
    return (dispatch, getState) => {

        const { books } = getState().books;
        const currentItems = books[osbn].chapters[chapterId].items;

        const reorderedItems = {};
        newKeys.forEach((key) => {
            reorderedItems[key] = currentItems[key];
        });


        dispatch({
            type: BOOK_CHAPTER_SORTED,
            osbn,
            chapterId,
            sortedItems: reorderedItems
        });


        dispatch(bookChaptersUpdated(osbn));
    };
}